import { useEffect } from 'react'
import { useResizeDetector } from 'react-resize-detector'

import { GraphType, GraphDefaultProps, GraphRender } from '../common'
import { useTimeLineGraphModel } from './container/model'
import { useTimeLineGraphOption, TimeLineGraphOptions } from './container/options'
import { useTimeLineGraphRenderOption } from './container/render'
import { useTimeLineGraphEvents } from './container/event'

import ReactEChartsCore from 'echarts-for-react/lib/core'
import * as echarts from 'echarts/core'
import { LineChart } from 'echarts/charts'
import { BarChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'

import {
  TooltipComponent,
  GridComponent,
  DataZoomComponent,
} from 'echarts/components'

import { Box } from '@mui/material'

echarts.use([
  TooltipComponent,
  GridComponent,
  DataZoomComponent,
  LineChart,
  BarChart,
  CanvasRenderer,
])

export const TimeLineGraph = <T,>({
  dashBoard,
  targetList,
  dataList,
  conditions,
  onChangeCondition,
  itemData,
  isResizing,
  graphRef,
  setCsv
}: GraphDefaultProps<T>) => {
  const { options } = itemData
  const { width, height, ref } = useResizeDetector()

  const graphOption = useTimeLineGraphOption({ dashBoard, options, targetList })
  const graphData = useTimeLineGraphModel({ dashBoard, dataList, conditions, graphOption })
  const renderOption = useTimeLineGraphRenderOption({ graphOption, graphData })
  const events = useTimeLineGraphEvents({ graphOption, onChangeCondition })

  useEffect(
    () => setCsv({ builder: () => graphData?.csvBuilder() }),
    [graphData, setCsv]
  )

  const { timeDef, valueDef, stackDef } = graphOption
  return (
    <Box ref={ref} width="100%" height="100%">
      <GraphRender
        invalid={!graphData || isResizing || ((height ?? 0) <= 10)}
        dashBoard={dashBoard}
        keys={[timeDef?.key, valueDef?.key]}
        optionKeys={[stackDef?.key]}
      >
        {(width && height) ? (
          <ReactEChartsCore
            ref={graphRef}
            echarts={echarts}
            notMerge={true}
            onEvents={events}
            option={renderOption}
            opts={{ renderer: 'canvas' }}
            style={{ width, height }}
            theme="insite"
          />
        ) : <></>}
      </GraphRender>
    </Box>
  )
}

export const TimeLineGraphFactory: GraphType = {
  title: 'タイムライングラフ',
  options: TimeLineGraphOptions,
  element: <T,>(props: GraphDefaultProps<T>) => <TimeLineGraph<T> {...props} />,
}
